const createWordData = (multipleRefinedUserStoriesData, heading) => {
  const wordData = [];
  multipleRefinedUserStoriesData.map((eachUserStory, index) => {
    if (!!eachUserStory) {
      wordData.push({
        heading: `${heading}_${index + 1}`,
        type: "subParagraphs",
        data: eachUserStory,
      });
      wordData.push({ type: "pageBreak" });
      return;
    }
  });
  return wordData;
};

export default createWordData;
